import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import UsersService from "@velocity-ehs/user-utils-module";
import { gql, useQuery } from "@apollo/client";

export const GET_APPLICATION_BUNDLES = gql`
  query applicationBundles(
    $filter: ApplicationBundleFilter
    $paginationInput: PaginationInput
  ) {
    applicationBundles(filter: $filter, paginationInput: $paginationInput) {
      items {
        id
        name
        applications {
          name
          id
        }
      }
    }
  }
`;

export const GET_CUSTOMER_APPLICATION_BUNDLES = gql`
  query getCustomerApplicationBundles(
    $customerId: ID
    $paginationInput: PaginationInput
  ) {
    customer(id: $customerId) {
      applications(paginationInput: $paginationInput) {
        items {
          id
          isAssigned
          name
          bundle {
            name
            id
          }
        }
      }
    }
  }
`;

export const GET_LOCATION_APPLICATION_BUNDLES = gql`
  query getLocationApplicationBundles(
    $locationId: String!
    $paginationInput: PaginationInput
  ) {
    location(id: $locationId) {
      applications(paginationInput: $paginationInput) {
        items {
          name
          bundle {
            name
            id
          }
        }
      }
    }
  }
`;

function useGetCustomerApplicationBundles() {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useQuery(GET_CUSTOMER_APPLICATION_BUNDLES, {
    variables: {
      customerId: UsersService.customer.id,
      paginationInput: {
        pageSize: 1000,
      },
    },
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    applications: result.data?.customer.applications.items || [],
  };
}

function useGetLocationApplicationBundles(locationId: string) {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useQuery(GET_LOCATION_APPLICATION_BUNDLES, {
    skip: !Boolean(locationId),
    variables: {
      locationId,
      paginationInput: {
        pageSize: 1000,
      },
    },
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    applications: result.data?.location.applications.items,
  };
}

function useGetApplicationBundles() {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useQuery(GET_APPLICATION_BUNDLES, {
    variables: {
      paginationInput: {
        pageSize: 1000,
      },
    },
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    applications: result.data?.applicationBundles.items || [],
  };
}

export {
  useGetCustomerApplicationBundles,
  useGetLocationApplicationBundles,
  useGetApplicationBundles,
};
